module.exports = __webpack_public_path__ + "img/q2.f691fc7f.svg";